<template>
  <div class="container">
    <div class="header-image-wrapper">
      <!-- <h1>A Team Of Us Is Smarter Than Any One of Us</h1> -->
      <h1>Build Products Users Love</h1>
    </div>
    <div class="display-2 mt-10">
      On Demand Development Teams
      <!-- 
      from designers to
      backend programmers -->
    </div>
    <p>Scale your team up or down every 2 weeks.</p>
    <div class="display-1 mb-3">
      We make it easy for startups to build your MVP.
    </div>
    <ul>
      <li>
        <div class="title">Build the right feature</div>
        Communicate your goals and our team of exprets to work with you to
        define the best solution. Once we agree on a solution we create taks and
        , we asseble and manage your team.
      </li>
      <li>
        <div class="title">See working code every 2 weeks</div>
        We deliver working code every 2 weeks so you can see where yout product
        is and can test the progress with real users.
      </li>
      <li>
        <div class="title">Clear Cost and Timelines.</div>
        <!-- Pay for progress not time spent. -->
        With our unique pay as you go feature development no more paying by the
        hour and wondering how much your bill will be. Define a feature, get a
        quote, and we deliver working code for you to review.
      </li>
    </ul>
    <!-- 
    <p>
      The Hive Network has the resources needed to build a great protuct your
      customers love.
    </p>
    <div class="display-1">
      Pay as you go feature development
    </div>
    <p>
      Do not pay for time pay for product progress
    </p> -->

    <!-- <div class="display-1">Do not pay for time pay for product progress</div> -->
  </div>
</template>
<style lang="scss" scoped>
.header-image-wrapper {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(/img/dev-bg.jpg) no-repeat center center;
  height: 400px;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-size: 4.7rem;
    // margin: 55px auto;
    padding-top: 150px;
  }
}
.num {
  font-size: 3rem;
}
.num-1 {
  padding-top: 15px;
}
.num-2 {
  padding-top: 100px;
}
.num-3 {
  padding-top: 200px;
}
.headline-text {
  font-size: 3.5rem;
}
</style>
<script>
export default {};
</script>
